import { axiosWithAuth } from "../../helpers";

export const finalService = {
	getSummary,
	getApplication,
	requestBusinessAndOwnerInfo,
	getNotes,
};

const API_URL = process.env.REACT_APP_API_URL;

function getSummary(applicationId) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/getApplicationSummary?applicationId=${applicationId}`,
	};

	return axiosWithAuth(options);
}

function getApplication(id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/getApplication?applicationId=${id}`,
	};

	return axiosWithAuth(options);
}

function getNotes({ id, page_index, page_size, deal_note_category }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${id}/notes?page_index=${page_index}&page_size=${page_size}&deal_note_category=${deal_note_category}`,
	};

	return axiosWithAuth(options);
}

function requestBusinessAndOwnerInfo({ applicationId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/applications/${applicationId}/send_business_and_owner_info_request`,
	};
	return axiosWithAuth(options);
}
